module.exports = __webpack_public_path__ + "static/media/swaple.8479bfda.png";